'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './documents.routes';

export class DocumentsComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('appApp.documents', [uiRouter])
  .config(routes)
  .component('documents', {
    template: require('./documents.html'),
    controller: DocumentsComponent,
    controllerAs: 'documentsCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/toc_policy/documents/documents.component.js